import axios from "axios";

const endpoint = process.env.REACT_APP_API_URL;

export const FETCH_VEHICLE_BEGIN = "FETCH_VEHICLE_BEGIN";
export const FETCH_VEHICLE_SUCCESS = "FETCH_VEHICLE_SUCCESS";
export const FETCH_VEHICLE_FAILURE = "FETCH_VEHICLE_FAILURE";
export const FETCH_EXISITNG_IMEI_BEGIN = "FETCH_EXISITNG_IMEI_BEGIN";
export const FETCH_EXISITNG_IMEI_SUCCESS = "FETCH_EXISITNG_IMEI_SUCCESS";
export const FETCH_EXISITNG_IMEI_FAILURE = "FETCH_EXISITNG_IMEI_FAILURE";
export const IMMOBILISE_VEHICLE_BEGIN = "IMMOBILISE_VEHICLE_BEGIN";
export const IMMOBILISE_VEHICLE_SUCCESS = "IMMOBILISE_VEHICLE_SUCCESS";
export const IMMOBILISE_VEHICLE_FAILURE = "IMMOBILISE_VEHICLE_FAILURE";

export const fetchVehicleBegin = () => ({
  type: FETCH_VEHICLE_BEGIN,
});

export const fetchVehicleSuccess = (vehicle) => ({
  type: FETCH_VEHICLE_SUCCESS,
  payload: vehicle,
});

export const fetchVehicleFailure = (error) => ({
  type: FETCH_VEHICLE_FAILURE,
  payload: { error },
});

export async function getVehicle(id) {
  return async (dispatch) => {
    dispatch(fetchVehicleBegin());
    try {
      const { data } = await axios.get(`${endpoint}/vehicles/${id}`);
      dispatch(fetchVehicleSuccess(data));
    } catch (err) {
      dispatch(fetchVehicleFailure(err));
    }
  };
}

export const checkExistingImeiBegin = () => ({
  type: FETCH_EXISITNG_IMEI_BEGIN,
});

export const checkExistingImeiSuccess = (payload) => ({
  type: FETCH_EXISITNG_IMEI_SUCCESS,
  payload: payload.existingImei,
});

export const checkExistingImeiFailure = (error) => ({
  type: FETCH_EXISITNG_IMEI_FAILURE,
  payload: { error },
});

export const checkExistingImei = async (imei) => {
  return async (dispatch) => {
    dispatch(checkExistingImeiBegin());
    try {
      const { data } = await axios.post(`${endpoint}/imeicheck`, {
        imei,
      });
      dispatch(checkExistingImeiSuccess(data));
    } catch (err) {
      dispatch(checkExistingImeiFailure(err));
    }
  };
};

export const createVehicle = async (vehicle) => {
  const created = await axios.post(`${endpoint}/vehicles`, vehicle);

  if (created.status !== 200) {
    throw new Error("Failed to create vehicle");
  }
  return created;
};

export const updateVehicle = async (id, update) => {
  const updated = await axios.patch(`${endpoint}/vehicles/${id}`, update);

  if (updated.status !== 200) {
    throw new Error("Failed to update vehicle");
  }
  return updated;
};

export const immobiliseVehicleBegin = () => ({
  type: IMMOBILISE_VEHICLE_BEGIN,
});

export const immobiliseVehicleSuccess = (payload) => ({
  type: IMMOBILISE_VEHICLE_SUCCESS,
  payload,
});

export const immobiliseVehicleFailure = (error) => ({
  type: IMMOBILISE_VEHICLE_SUCCESS,
  payload: { error },
});

export const immobiliseVehicle = async (id, status) => {
  return async (dispatch) => {
    dispatch(immobiliseVehicleBegin());
    try {
      const data = {
        out1: status,
      };
      await axios.put(`${endpoint}/vehicles/${id}/immobilise`, data);

      dispatch(immobiliseVehicleSuccess(status));
    } catch (err) {
      dispatch(immobiliseVehicleFailure(err));
    }
  };
}
